import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import UserInput from "../../components/UserInput/UserInput";
import history from "../../history";
import axios from "../../utils/Axios/axiosProxy";
import styles from "./UserEntry.module.scss";
import { validateInput } from "../../utils/Functions/functions";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";

export function ResetPassword(props) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordError, setPasswordError] = React.useState("");
  const [pwReseted, setPWreseted] = React.useState(false);
  const JWT = props.match.params.JWT;

  useEffect(() => {
    const getUser = () => {
      let data = { params: { resetpwtoken: JWT } };
      axios
        .get("/api/user/reset", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response.data);
          setEmail(response.data.email);
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        })
        .catch((error) => console.log("submitToDB error", error));
    };
    getUser();
  }, [JWT]);

  const updatePassword = () => {
    let data = { email, resetpwtoken: JWT, password };
    axios
      .put("/api/user/updatepw", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.statusText === "OK") {
          setPWreseted(true);
        }
        console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  return (
    <div className={styles.UserEntryContainer}>
      <div className={styles.UserEntryContent}>
        <div>
          <h2 className={styles.UserEntryTitle}>Update Password</h2>
        </div>
        <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
          {pwReseted ? (
            <>
              <p className={`${styles.AccountCreatedText} OrangeFont`}>
                Password successfully updated
              </p>
            </>
          ) : (
            <>
              <UserInput
                key="email"
                name="Email"
                id="email"
                className={userInputStyle.RegInput}
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                disabled
              />
              <UserInput
                key="password"
                name="Password"
                id="password"
                type="password"
                className={userInputStyle.RegInput}
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setPasswordError(
                    validateInput("password", event.target.value).password
                  );
                }}
              />
              <div className={styles.UserEntryErrorMessageContainer}>
                <span className={styles.UserEntryErrorMessage}>
                  {passwordError}
                </span>
              </div>
            </>
          )}
          <div className={styles.UserEntryButton}>
            <Button
              onClick={() => {
                if (
                  passwordError.length === 0 &&
                  password.length > 0 &&
                  email.length > 0 &&
                  !pwReseted
                ) {
                  updatePassword();
                } else if (pwReseted) {
                  history.push("/signin");
                }
              }}
              className={`ToreaBay Medium MarginHorizontal`}
            >
              {pwReseted ? "Go to login" : "Update password"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
